// extracted by mini-css-extract-plugin
export var linkText = "_nd-0";